import { ExpressionType } from '../../IExpression';
import { IAsyncExpression } from '../async/IAsyncExpression';
import { IFunctionExpression } from '../function/IFunctionExpression';
import { IReferenceExpression } from '../reference/IReferenceExpression';
import { IValueExpression } from '../value/IValueExpression';

/**
 * Tipo che rappresenta un'assegnazione al livello più basso
 * possibile, ovvero sul singolo campo.
 * Se viene modificato, allineare anche `AllAssignableExpressionTypes`.
 */
export type IAssignableExpression =
  | IValueExpression
  | IReferenceExpression
  | IAsyncExpression
  | IFunctionExpression;

export type AssignableExpressionType = IAssignableExpression['type'];

/**
 * Elenco di tutti i tipi di espressioni che possono essere assegnate.
 * L'order è importante perché è quello in cui vengono visualizzate le
 * espressioni nell'editor.
 */
export const AllAssignableExpressionTypes = [
  ExpressionType.Value,
  ExpressionType.Reference,
  ExpressionType.Function,
  ExpressionType.Async,
] as const;
